// Regner beløbet til gratis fragt om til kundens valuta (se
// snippets/kast-fragt-bar.liquid). Grænsen står i danske kroner, og Shopify
// giver kursen fra butikkens valuta i window.Shopify.currency. Elementet
// tegnes forfra hver gang kurven opdateres, så udregningen sker ved indsættelse.
if (!customElements.get('kast-fragt-bar')) {
  customElements.define(
    'kast-fragt-bar',
    class KastFragtBar extends HTMLElement {
      connectedCallback() {
        const valuta = window.Shopify?.currency?.active || 'DKK';
        const kurs = Number(window.Shopify?.currency?.rate) || 1;
        const graense = Number(this.dataset.graense) * kurs * 100;
        const subtotal = Number(this.dataset.subtotal);
        if (!graense) return;

        const mangler = graense - subtotal;
        this.querySelector('[data-fyld]').style.width = `${Math.min(100, (subtotal / graense) * 100)}%`;
        this.classList.toggle('kast-fragt-bar--naaet', mangler <= 0);

        const tekst = this.querySelector('[data-tekst]');
        if (mangler <= 0) {
          tekst.textContent = this.dataset.tekstNaaet;
          return;
        }
        const beloeb = new Intl.NumberFormat(document.documentElement.lang || 'da', {
          style: 'currency',
          currency: valuta,
          maximumFractionDigits: 0,
        }).format(Math.ceil(mangler / 100));
        tekst.textContent = this.dataset.tekstMangler.replace('[beloeb]', beloeb);
      }
    }
  );
}
